// Service to upload generated images to R2 storage via backend
export const uploadImageToR2 = async (imageBlob, filename) => {
  try {
    console.log(`📤 [R2 UPLOAD START] Uploading ${filename} to R2 storage...`);
    console.log(`📤 [R2 UPLOAD] Blob size: ${imageBlob.size} bytes, type: ${imageBlob.type}`);
    console.log(`📤 [R2 UPLOAD] Environment: ${process.env.NODE_ENV || 'development'}`);

    // Validate blob
    if (!imageBlob || imageBlob.size === 0) {
      throw new Error('Invalid blob: empty or null');
    }

    // Create FormData to send the image
    const formData = new FormData();
    formData.append('file', imageBlob, filename);
    formData.append('filename', filename);

    console.log(`📤 [R2 UPLOAD] FormData created with ${formData.has('file') ? 'file present' : 'NO FILE'}`);

    // Get the correct backend URL
    const API_BASE = process.env.NODE_ENV === 'production'
      ? 'https://renovate-library-service-jo572.ondigitalocean.app'
      : 'http://localhost:8000';

    const uploadUrl = `${API_BASE}/api/upload-image`;
    console.log(`📤 [R2 UPLOAD] Uploading to: ${uploadUrl}`);
    console.log(`📤 [R2 UPLOAD] Request started at: ${new Date().toISOString()}`);

    // Upload to backend R2 endpoint with timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout

    try {
      const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      console.log(`📤 [R2 UPLOAD] Response received: ${response.status} ${response.statusText}`);
      console.log(`📤 [R2 UPLOAD] Response headers:`, Object.fromEntries(response.headers.entries()));

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`❌ [R2 UPLOAD FAILED] Status ${response.status}:`, errorText);
        throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const result = await response.json();
      console.log(`✅ [R2 UPLOAD SUCCESS] URL: ${result.url}`);
      console.log(`✅ [R2 UPLOAD SUCCESS] Full result:`, result);

      // Verify the URL is valid
      if (!result.url || !result.url.startsWith('http')) {
        throw new Error(`Invalid URL returned: ${result.url}`);
      }

      return result.url;

    } catch (fetchError) {
      clearTimeout(timeoutId);
      if (fetchError.name === 'AbortError') {
        console.error('❌ [R2 UPLOAD TIMEOUT] Request timed out after 30 seconds');
        throw new Error('Upload timed out after 30 seconds');
      }
      throw fetchError;
    }

  } catch (error) {
    console.error('❌ [R2 UPLOAD ERROR] Upload failed:', error);
    console.error('❌ [R2 UPLOAD ERROR] Error type:', error.constructor.name);
    console.error('❌ [R2 UPLOAD ERROR] Error name:', error.name);
    console.error('❌ [R2 UPLOAD ERROR] Error message:', error.message);
    console.error('❌ [R2 UPLOAD ERROR] Error stack:', error.stack);
    throw error;
  }
};

// Convert blob URL to blob object
export const blobUrlToBlob = async (blobUrl) => {
  try {
    console.log(`🔄 [BLOB CONVERT] Converting blob URL to blob: ${blobUrl.substring(0, 50)}...`);

    if (!blobUrl || !blobUrl.startsWith('blob:')) {
      throw new Error(`Invalid blob URL: ${blobUrl}`);
    }

    const response = await fetch(blobUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch blob URL: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    console.log(`✅ [BLOB CONVERT] Converted successfully: ${blob.size} bytes, type: ${blob.type}`);

    return blob;
  } catch (error) {
    console.error('❌ [BLOB CONVERT ERROR] Failed to convert blob URL to blob:', error);
    console.error('❌ [BLOB CONVERT ERROR] Blob URL:', blobUrl);
    throw error;
  }
};

// Generate filename for uploaded images
export const generateFilename = (source, index) => {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
  const sourcePrefix = source.toLowerCase().replace(/\s+/g, '_');
  return `${sourcePrefix}_${timestamp}_${index}.png`;
};
